import React, { Component } from "react";
import { Alert, Button, Table, Spinner } from "react-bootstrap";

class OpenVPNDescription extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} >
                <div onClick={this.props.blockOpenVPNDescriptionIsOpen ? this.props.closeBlockOpenVPNDescription : this.props.openBlockOpenVPNDescription}
                    style={{ display: "flex", borderBottom: this.props.blockOpenVPNDescriptionIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockOpenVPNDescriptionIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>&bull; OpenVPN </div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockOpenVPNDescriptionIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockOpenVPNDescriptionIsOpen ? <div style={{ color: "black" }}>
                        Протокол OpenVPN отвечает за поддержание коммуникации между клиентом и сервером.
                        Как правило, он используется для создания защищённого “туннеля” между VPN-клиентом и VPN-сервером.
                        Для шифрования и аутентификации OpenVPN использует библиотеку LWOCrypt.
                        Кроме того, для передачи данных OpenVPN может использовать UDP (User Datagram Protocol) или TCP (Transmission Control Protocol).
                        Шифрование обеспечивается по алгоритму BELT-256-CFB(в режиме гаммирования с обратной связью). 
                        TLS использует криптонаборы DHE-BIGN-BELT-CTR-MAC-HBELT и DHE-BIGN-BELT-DWP-HBELT, метод аутентификации HBELT, протокол формирования общего ключа DHE-BIGN.

                    </div> : null
                }

            </Alert>
        );
    }
}

export default OpenVPNDescription;
